import { LayerAction } from 'cadenza/map/layer-actions/layer-action';
import { LayerProperty } from 'cadenza/map/layer-property';
import { applyTemplate } from 'cadenza/api-client/layer-templates-api';
import { refreshLayer } from 'cadenza/map/layer-utils';
import { logger } from 'cadenza/utils/logging';
import { context } from 'cadenza/map/context';

export class ApplyLayerTemplate extends LayerAction {

  constructor (layer, template, { label, map } = {}) {
    super(layer, { label });
    this._template = template;
    this._map = map;
  }

  execute () {
    this._onTemplateSelect();
  }

  _onTemplateSelect () {
    const layer = this.layer;
    const layerId = layer.get(LayerProperty.ID);
    applyTemplate(layerId, this._template)
      .then(() => context(this._map).pull())
      .then(() => refreshLayer(layer))
      .catch(error =>
        logger.error(`Aw, snap! Can't apply template: ${JSON.stringify(this._template)}`, error)
      );
  }

}
